// Text to Binary Tool — convert text to and from 8-bit binary (UTF-8).
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const textToBinaryTool: Tool = {
  id: "text-to-binary",
  name: () => m.tb_tool_name(),
  description: () => m.tb_tool_description(),
  icon: "💻",
  basePath: "/text-to-binary",
  status: "stable",
  tags: ["binary", "text", "encode", "developer"],
  pages: [
    {
      name: () => m.tb_nav_main(),
      path: "/text-to-binary",
      description: () => m.tb_nav_main_desc(),
      icon: "💻",
    },
  ],
};
